import { render, staticRenderFns } from "./StartShiftForm.vue?vue&type=template&id=89b5fa70"
import script from "./StartShiftForm.vue?vue&type=script&lang=js"
export * from "./StartShiftForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports